export const salesLeadFragment = `
  __typename
  ... on User {
    id
    name
  }
  ... on Team {
    id
    name
  }
`;
